import com.github.chosamuel.kishibe.application.*
import com.github.chosamuel.kishibe.application.renderer.clear
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.ui.Radio
import kotlinx.browser.window
import org.khronos.webgl.WebGLRenderingContext
import kotlin.math.sqrt

typealias GL = WebGLRenderingContext
typealias SpringParticles2D = List<List<SpringParticle>>
val radio = Radio(numBtns = 2)

fun main() {
    radio.appendToDocument()
}

//TODO Create spring system from grid
val HEIGHT = window.innerHeight
val WIDTH = window.innerWidth
val scale = 0.7
val gs = if(HEIGHT > WIDTH) WIDTH*scale else HEIGHT*scale
val dim = 30
val spacing = gs/(dim-1).toDouble()
val points = createSquareGrid(dim,gs)
val springParticles = springParticlesFromPoints(points)
val springConfiguration = createSquareSpringConfiguration(springParticles)
val springDiagonalsCfg = createDiagonalSpringConfiguration(springParticles)

//CLICKABLE
var closeX = 0
var closeY = 0
var clickable = false

val app = Application {
    setup {
        setActiveShader(vs,fs)
        onClick = {
            val mouse = Vector2(mouseX,mouseY)
            var minDist = 2000.0
            springParticles.forEachIndexed { y, row ->
                row.forEachIndexed { x, p->
                    val d = p.pos.distanceTo(mouse)
                    if(d < minDist){
                        minDist = d
                        closeX = y
                        closeY = x
                    }
                    if(d < 15.0){
                        clickable = true
                    }
                }
            }
            springParticles[closeX][closeY].fixed = true
        }
        radio.onClickOuter = {
            onClick()
            mouseClicked = true
        }
        onRelease = {
            clickable = false
            springParticles[closeX][closeY].fixed = false
        }
        radio.onReleaseOuter = {
            mouseClicked = false
            onRelease()
        }
    }

    draw {
        val timeUniform = gl.getUniformLocation(defaultShader.program,"time")
        gl.uniform1f(timeUniform,frameCount.toFloat())

        if(mouseClicked){
            val mouse = Vector2(mouseX,mouseY)
            springParticles[closeX][closeY].pos = mouse
        }
        clear(0.0)
        val lateralForces = calculateSpringForces(
            springParticles,
            springConfiguration,
            spacing
        )
        val diagonalSpacing = sqrt((spacing*spacing) + (spacing*spacing))
        val diagonalForces = calculateSpringForces(
            springParticles,
            springDiagonalsCfg,
            diagonalSpacing
        )
        springParticles.forEachIndexed {y,row ->
            row.forEachIndexed {x,p ->
                val force = diagonalForces[y][x] + lateralForces[y][x]
                p.pos += force
            }
        }

        when(radio.mode){
            1 -> {
                val m = springParticleToTriangleMesh(springParticles)
                m.draw(GL.TRIANGLES)
            }
            else -> {
                val m = springParticleGridToLineMesh(springParticles)
                m.draw(GL.LINES)
            }
        }

    }
}
